import { Tabs, TabsContent, TabsList, TabsTrigger } from '@marine/ui/tabs';
import { RiUserLine, RiLockPasswordLine, RiSettings4Line } from '@remixicon/react';
import { ProfileInfoCard } from './components/ProfileInfoCard';
import { SecurityCard } from './components/SecurityCard';
import { TwoFactorCard } from './components/TwoFactorCard';

export function ProfilePage() {
  return (
    <div className="container max-w-4xl py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold tracking-tight">Profile Settings</h1>
        <p className="text-muted-foreground mt-2">
          Manage your account settings and preferences
        </p>
      </div>

      <Tabs defaultValue="profile" className="w-full">
        <TabsList className="grid w-full grid-cols-3 mb-8">
          <TabsTrigger value="profile" className="gap-2">
            <RiUserLine className="h-4 w-4" />
            <span className="hidden sm:inline">Profile</span>
          </TabsTrigger>
          <TabsTrigger value="security" className="gap-2">
            <RiLockPasswordLine className="h-4 w-4" />
            <span className="hidden sm:inline">Security</span>
          </TabsTrigger>
          <TabsTrigger value="preferences" className="gap-2">
            <RiSettings4Line className="h-4 w-4" />
            <span className="hidden sm:inline">Preferences</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="profile" className="space-y-4">
          <ProfileInfoCard />
        </TabsContent>

        <TabsContent value="security" className="space-y-4">
          <SecurityCard />
          <TwoFactorCard />
        </TabsContent>

        <TabsContent value="preferences" className="space-y-4">
          <div className="text-center text-muted-foreground py-12">
            Preferences section coming soon
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
